import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class DegradationWarning extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'DegradationWarning',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, DegradationWarning.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DegradationWarning);
    } else {
      this.stack = new Error().stack;
    }
  }
}
